import {HashPerSecond, Speed} from './DemonstrationDatabase';

export default (hashrate: HashPerSecond, speed: Speed) =>
  (hashrate - (hashrate / 10) * Math.random()) * (speed / 100);
